module.exports = __webpack_public_path__ + "static/media/onespan.7dfdeb31.jpg";